<template>
  <router-link class="mdl-navigation__link" :to="href">
    <i v-show="icon" class="material-icons">{{icon}}</i>
    <div>
      <slot></slot>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: '/'
    },
    icon: String
  }
}
</script>

<style scoped lang="sass">
.mdl-layout__drawer
  .mdl-navigation .mdl-navigation__link
    div
      display: inline-block
i
  font-size: 24px
  padding-right: 15px
</style>



// WEBPACK FOOTER //
// src/components/Navlink.vue